import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid'

import type { Label } from '@models/Label'

import { SelectObject } from '../../../../core/components/SelectObject'
import { useSaveEvent } from '../../hooks/useSaveEvent'
import type { Project } from '../../types/Project'

const mapToLabel = (v: string): Label => ({ code: v, label: v })

interface Props {
  project: Project
  selectableLabels?: string[]
  handleClose: () => void
}

export const Labels = ({
  handleClose,
  project,
  selectableLabels = [],
}: Props) => {
  const { mutate: saveEvent } = useSaveEvent()

  const { aanvraagID, labels: labelsFromProject = [] } = project
  const options = selectableLabels.map(mapToLabel)
  const selectedOptions = labelsFromProject.map(mapToLabel)

  const [labels, setLabels] = useState<Label[]>(selectedOptions)

  return (
    <>
      <DialogTitle>Labels wijzigen</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <DialogContentText>
              Selecteer de labels die u wilt toepassen.
            </DialogContentText>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <SelectObject
              multiple
              options={options}
              value={labels}
              onChange={setLabels}
              label="Labels"
              isOptionEqualToValue={(option, value) =>
                option.code === value.code
              }
              disableClearable
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" autoFocus>
          Sluiten
        </Button>
        <Button
          onClick={() =>
            saveEvent(
              {
                id: aanvraagID,
                type: 'update_labels',
                source: 'manual',
                data: {
                  labels: labels.map(({ code }) => code),
                },
              },
              {
                onSuccess: () => handleClose(),
              },
            )
          }
          color="primary"
        >
          Opslaan
        </Button>
      </DialogActions>
    </>
  )
}
